/**
 * @ngInject
 * Takes a class and does a jquery animate on it.
 */

function scrollTo() {
  return {
    restrict: "A",
    link: function link(scope, elem, attrs) {
      elem[0].addEventListener("click", function(event) {
        // console.log("scrollTo", attrs.scrollTo);
        $("html, body").animate(
          { scrollTop: $("." + attrs.scrollTo).offset().top },
          "slow"
        );
      });
    }
  };
}
